import React from 'react';
import styles from '../InternalAdminTool.module.scss';
import {Button, Tooltip} from '@tag/tag-components-react-v4';
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import AppRolesService from "../../../General/services/AppRolesService";
import {CustomerForInternalAdminTool} from "../../types/CustomerForInternalAdminTool";
import { ProjectAccents } from "../../../General/config/projectAccents";

interface CustomerDetailsProps {
  foundCustomer: CustomerForInternalAdminTool;
  title?: string;
  hideLinkedStatus?: boolean;
  setSelectedCustomer: (customer: any) => void;
}

const CustomerDetails: React.FC<CustomerDetailsProps> = ({
  foundCustomer,
  title = "Customer Found",
  hideLinkedStatus = false,
  setSelectedCustomer
}) => {
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  let canConfigureACC = AppRolesService.canUserConfigureACC(accounts, isAuthenticated);
  
  const renderButton = ()=>  {
    return <Button
        accent={ProjectAccents.CareCompliance}
        className={styles.connectButton}
        disabled={!canConfigureACC}
        onClick={(e) => {
          setSelectedCustomer(foundCustomer);
        }}
    >
      Link
    </Button>
  }
  
  return (
    <div className={styles.customerDetails}>
      <h3 className={styles.customerTitle}>{title}</h3>
      <div className={styles.customerInfo}>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Client ID:</span>
          <span className={styles.infoValue}>{foundCustomer.clientId}</span>
        </div>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Name:</span>
          <span className={styles.infoValue}>{foundCustomer.name}</span>
        </div>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Website:</span>
          {
            <a
                href={foundCustomer.website}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.infoLink}
            >
              {foundCustomer.website}
            </a>
          }
        </div>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Database:</span>
          <span className={styles.infoValue}>{foundCustomer.databaseName}</span>
        </div>
      </div>
      {!hideLinkedStatus && (
        <>
          {!foundCustomer.linked && canConfigureACC ? renderButton() : undefined }
          {!foundCustomer.linked && !canConfigureACC ?
              <Tooltip background={'dark'} tooltipFor={renderButton()}>You require the configureACC role for
                this. Please contact HSC DevOps.</Tooltip> : undefined}
          {foundCustomer.linked ? 
            <div className={styles.alreadyLinked}>
              This client is already linked
            </div> : undefined
          }
        </>
      )}
    </div>
  );
};

export default CustomerDetails;
